const _ = require('lodash')

export default {
    id: 'K',
    name: 'Actions',
    entities: _.concat(
        [
            require('./keenpointActions/configuration/sectorOfActivity').entity,
            require('./keenpointActions/configuration/function').entity,
            require('./keenpointActions/configuration/actionType').entity,
            require('./keenpointActions/configuration/projectType').entity,
            require('./keenpointActions/referential/group').entity,
            require('./keenpointActions/referential/company').entity,
            require('./keenpointActions/referential/contact').entity,
            require('./keenpointActions/referential/groupAndCompany').entity,
            require('./keenpointActions/dossier/project').entity,
            require('./keenpointActions/dossier/action').entity,
        ],
        require('./keenpointActions/staticEntities').entities,
        require('./keenpointActions/entitiesActivities').entities,
        [
            require('./keenpointActions/dashboard').entity,
        ]
    ),
    description: '',
    modules:
        _.concat(
            [
                require('./keenpointActions/configuration/sectorOfActivity').module_,
                require('./keenpointActions/configuration/function').module_,
                require('./keenpointActions/configuration/actionType').module_,
                require('./keenpointActions/configuration/projectType').module_,
                require('./keenpointActions/referential/group').module_,
                require('./keenpointActions/referential/company').module_,
                require('./keenpointActions/referential/contact').module_,
                require('./keenpointActions/dossier/project').module_,
                require('./keenpointActions/dossier/action').module_,
            ],
            require('./keenpointActions/modulesActivities').modules
        ),

}
